import React from 'react';
import {FullPageLoading} from 'components/Loading';

export const Index = () => {
	return <FullPageLoading />;
};

export default Index;
